"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

const navLinks = [
  { label: "Inicio", href: "/homepage" },
  { label: "Productos", href: "/products" },
  { label: "Servicios", href: "/homepage#servicios" },
  { label: "Portafolio", href: "/homepage#portafolio" },
  { label: "Contacto", href: "/homepage#contacto" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? "bg-evolvia-bg/95 backdrop-blur-2xl border-b border-evolvia-border" :"bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-6">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center gap-3 group flex-shrink-0">
            <Image
              src="/assets/images/EVOLVIA_LOGO-1772803973696.png"
              alt="Evolvia 3D logo"
              width={140}
              height={40}
              className="object-contain h-10 w-auto"
              priority
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map((link) => {
              const isActive = pathname === link?.href;
              return (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className={`px-4 py-2 text-sm font-500 tracking-wide transition-all duration-300 ${
                    isActive
                      ? "text-evolvia-copper" :"text-evolvia-text-secondary hover:text-evolvia-text-primary"
                  }`}
                >
                  {link?.label}
                </Link>
              );
            })}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              href="/homepage#contacto"
              className="btn-primary text-xs py-2.5 px-5"
            >
              Solicitar Presupuesto
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden flex flex-col gap-1.5 p-2 rounded-lg hover:bg-white/5 transition-colors"
            aria-label="Abrir menú"
          >
            <span
              className={`block h-0.5 w-6 bg-evolvia-text-primary transition-all duration-300 ${
                mobileOpen ? "rotate-45 translate-y-2" : ""
              }`}
            />
            <span
              className={`block h-0.5 w-6 bg-evolvia-text-primary transition-all duration-300 ${
                mobileOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`block h-0.5 w-6 bg-evolvia-text-primary transition-all duration-300 ${
                mobileOpen ? "-rotate-45 -translate-y-2" : ""
              }`}
            />
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-all duration-400 ${
          mobileOpen ? "pointer-events-auto" : "pointer-events-none"
        }`}
      >
        <div
          className={`absolute inset-0 bg-evolvia-bg/97 backdrop-blur-2xl transition-opacity duration-400 ${
            mobileOpen ? "opacity-100" : "opacity-0"
          }`}
          onClick={() => setMobileOpen(false)}
        />
        <nav
          className={`absolute top-20 left-0 right-0 p-6 flex flex-col gap-2 transition-all duration-400 ${
            mobileOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
          }`}
        >
          {navLinks?.map((link) => {
            const isActive = pathname === link?.href;
            return (
              <Link
                key={link?.href}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className={`px-5 py-4 text-base font-500 transition-all duration-300 border-b ${
                  isActive
                    ? "text-evolvia-copper border-evolvia-border" :"text-evolvia-text-secondary hover:text-evolvia-text-primary border-transparent"
                }`}
              >
                {link?.label}
              </Link>
            );
          })}
          <Link
            href="/homepage#contacto"
            onClick={() => setMobileOpen(false)}
            className="btn-primary text-center mt-4"
          >
            Solicitar Presupuesto
          </Link>
        </nav>
      </div>
    </>
  );
}